import get from 'lodash.get';

import { selectNotification } from '../../redux/ui/selectors';
import { createDeepEqualSelector } from '../../redux/utils/selectors';

export const selectType = createDeepEqualSelector(selectNotification, (notification) => notification.type || 'info');

export const selectNotificationOptions = createDeepEqualSelector(selectNotification, (notification = {}) => ({
  message: get(notification, 'title', ''),
  description: get(notification, 'description', ''),
  duration: get(notification, 'duration', 0),
}));
